// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"c4ea7860","172":"684665d0","493":"fe89a026","553":"c68e0210","940":"f08085ee"}[chunkId] + ".chunk.js";
};